import { Dialog } from '@material-ui/core';
import { Button } from '@vadiun/react-components';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import {
  LocationCity,
  DomainTwoTone,
  BlurOn,
  BorderClear,
  OfflineBolt
} from '@material-ui/icons';
import * as Yup from 'yup';
import { FC } from 'react';
import { SectorPayloadToCreate } from 'app/client/clientBusiness/models/businessSectors';
interface SectorCreateEditModalProps {
  isOpen: boolean;
  onSubmit: (payload: any) => Promise<void>;
  onCancel: () => void;
  initialValues: { name: string };
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Campo requerido')
});

const SectorCreateEditModal: FC<SectorCreateEditModalProps> = ({
  isOpen,
  onSubmit,
  onCancel,
  initialValues
}) => {
  const handleSubmit = async (
    values: { name: string },
    { setSubmitting }: any
  ) => {
    try {
      const payload: SectorPayloadToCreate = {
        name: values.name
      };
      await onSubmit(payload);
    } catch (error) {
      console.error('Error al agregar el sector:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onCancel} maxWidth="sm">
      <div className="flex flex-col ">
        <div className="flex flex-col items-center m-0 mb-4">
          <div className="relative">
            <BlurOn
              style={{
                fontSize: 220,
                color: '#ff7070',
                opacity: 0.7
              }}
            />
            <BorderClear
              style={{
                fontSize: 60,
                color: '#810000',
                marginBottom: '1rem',
                position: 'absolute',
                right: 14,
                top: 145
              }}
            />
            <OfflineBolt
              style={{
                fontSize: 40,
                color: '#f70000',
                marginBottom: '1rem',
                position: 'absolute',
                right: 130,
                top: 125
              }}
            />

            <LocationCity
              style={{
                fontSize: 70,
                color: '#ff4e4e',
                marginBottom: '1rem',
                position: 'absolute',
                right: -2,
                top: 0
              }}
            />
            <DomainTwoTone
              style={{
                fontSize: 40,
                color: '#cd3535',
                position: 'absolute',
                right: 135,
                top: 55
              }}
            />
          </div>
          <h2 className="text-2xl font-bold text-center text-red-900 ">
            {initialValues.name?.length ? 'Editar' : 'Crear'} Rubro
          </h2>
        </div>
        <h2 className="flex justify-center text-lg  mb-4 border-t-2 border-red-300 pt-4 mx-4">
          {initialValues.name?.length ? 'Modifique el nombre del rubro' : 'Ingrese el nombre del rubro'}
        </h2>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, isValid, dirty }) => (
            <Form className="flex w-full flex-col gap-4 items-center px-4 pb-4">
              <div className="flex text-center ">
                <Field
                  component={TextField}
                  name="name"
                  label="Rubro"
                  type="text"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  style={{ width: '190px' }}
                />
              </div>
              <div className="flex w-full justify-between gap-4 mt-4">
                <Button
                  type="button"
                  variant="light"
                  color="gray"
                  onClick={onCancel}
                  disabled={isSubmitting}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={!isValid || !dirty || isSubmitting}
                >
                  Confirmar
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Dialog>
  );
};

export default SectorCreateEditModal;
